import { render, staticRenderFns } from "./DealerHeader.vue?vue&type=template&id=5516d79c&scoped=true&"
import script from "./DealerHeader.vue?vue&type=script&lang=js&"
export * from "./DealerHeader.vue?vue&type=script&lang=js&"
import style0 from "./DealerHeader.vue?vue&type=style&index=0&id=5516d79c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5516d79c",
  null
  
)

export default component.exports